import { usePanelState } from '../model/usePanelState';
import { SourcesList } from './SourcesList';
import { SourceDetailPanel } from './SourceDetailPanel';

interface Props {
  assistantId: string;
}

/**
 * Вкладка «База знаний» ассистента.
 *
 * Двухпанельный layout:
 *  - Слева (320px фиксировано) — SourcesList со всеми источниками
 *  - Справа (остаток) — SourceDetailPanel со стейт-машиной 4 состояний
 *
 * Состояние правой панели хранится в usePanelState (useState). Refresh
 * страницы возвращает в welcome — это сознательное решение (не shareable URL).
 *
 * Высоту контейнера задаём minHeight чтобы карточки не «сжимались» вверх
 * на пустых состояниях. Можно превратить в height: '100%' если родитель
 * (Card в AssistantDetailPage) будет это поддерживать.
 */
export function KnowledgeBaseTab({ assistantId }: Props) {
  const { state, goWelcome, goAddDocument, goAddSite, selectSource } = usePanelState();

  const selectedSourceId = state.mode === 'detail' ? state.sourceId : null;

  return (
    <div
      style={{
        display: 'flex',
        gap: 16,
        minHeight: 600,
      }}
    >
      {/* Левая панель: список источников */}
      <div
        style={{
          width: 320,
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <SourcesList
          assistantId={assistantId}
          selectedSourceId={selectedSourceId}
          onSelectSource={selectSource}
          onAddDocument={goAddDocument}
          onAddSite={goAddSite}
        />
      </div>

      {/* Разделитель */}
      <div
        style={{
          width: 1,
          background: '#f0f0f0',
          flexShrink: 0,
        }}
      />

      {/* Правая панель: детали / форма / welcome */}
      <div style={{ flex: 1, minWidth: 0, overflow: 'auto' }}>
        <SourceDetailPanel
          assistantId={assistantId}
          state={state}
          onGoWelcome={goWelcome}
          onAddDocument={goAddDocument}
          onAddSite={goAddSite}
          onSelectSource={selectSource}
        />
      </div>
    </div>
  );
}
